exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-data-table[data-v-5c667054] .sticky-header{position:sticky;top:0;z-index:1}.v-data-table[data-v-5c667054] .v-data-table__wrapper{margin-top:0;overflow:unset}.slotWarningsTable[data-v-5c667054] tbody tr:hover{background-color:rgba(171,59,123,.10588235294117647)!important}.rowWasEdited[data-v-5c667054]{border:2px solid #ab3b7c;padding:2px}", ""]);

// exports
